export const mockColumns = [
  {
    field: 'placement.additional_advantage',
    headerName: 'placement.additional_advantage',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.additional_condition',
    headerName: 'placement.additional_condition',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.balcony_area',
    headerName: 'placement.balcony_area',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.bathrooms',
    headerName: 'ванні кімнати',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.bedrooms',
    headerName: 'спальні',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.house',
    headerName: 'номер будинку',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.living_area',
    headerName: 'житлова площа, м²',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement_status.module_name',
    headerName: 'статус',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.status',
    headerName: 'статус',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.type',
    headerName: 'placement.type',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.price_per_sq_m_alternative',
    headerName: 'placement.price_per_sq_m_alternative',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.rooms',
    headerName: 'кількість кімнат',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row0',
    headerName: 'зовнішній простір',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row1',
    headerName: 'балкон/лоджія',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row2',
    headerName: 'тераса',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row4',
    headerName: 'placement.row4',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row5',
    headerName: 'placement.row5',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row6',
    headerName: 'placement.row6',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row7',
    headerName: 'placement.row7',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row8',
    headerName: 'placement.row8',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row9',
    headerName: 'номер будинку',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.section',
    headerName: 'черга',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.tag',
    headerName: 'вид з вікон',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.total_price_alternative',
    headerName: 'placement.total_price_alternative',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.numeration',
    headerName: 'номер помешкання',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.floor',
    headerName: 'поверх',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.planning_type',
    headerName: 'тип',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.total_area',
    headerName: 'загальна площа, м²',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.price_per_sq_m',
    headerName: 'ціна, $/м²',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.total_price',
    headerName: 'загальна вартість, $',
    type: 'number',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement_status.crosstable_name',
    headerName: 'статус',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.note',
    headerName: 'сторона будинку',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'placement.row3',
    headerName: 'краєвид',
    type: 'string',
    headerAlign: 'center',
    align: 'center',
  },
];
export const mockRows = [
  {
    id: 'fs_sbu77fmpc6vxtl3t_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '201',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.70',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#d0da66',
    'placement.status': 'інтерес',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'інтерес',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_5pagr54n51elr8td_uid',
    main_filter_img: 'https://showfiles.net/2W6wjc2h.jpg',
  },
  {
    id: 'fs_h060jpq8uan6vdae_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '202',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.16',
    'placement.rooms': 'Смарт',
    'placement.total_price': '84640.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFay2R.jpg',
  },
  {
    id: 'fs_2hontdjis3uyhdwj_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '203',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '20.62',
    'placement.rooms': 'Смарт',
    'placement.total_price': '82480.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFjchG.jpg',
  },
  {
    id: 'fs_qss1ulekgzkvddw3_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '204',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '24.45',
    'placement.rooms': 'Смарт',
    'placement.total_price': '97800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця Замарстинівська',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WlaAg2V.jpg',
  },
  {
    id: 'fs_rc9rlirrebhgnwpa_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '205',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '22.15',
    'placement.rooms': 'Смарт',
    'placement.total_price': '88600.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця Замарстинівська',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHuFP2Z.jpg',
  },
  {
    id: 'fs_ls8jjfljir9qjgct_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '206',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.58',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86320.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця Замарстинівська',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHFQg28.jpg',
  },
  {
    id: 'fs_82dkzzehb9thnz0c_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '207',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '22.07',
    'placement.rooms': 'Смарт',
    'placement.total_price': '88280.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця Замарстинівська',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WD6Ag21.jpg',
  },
  {
    id: 'fs_fnpudk7dzi51ngwr_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '208',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.78',
    'placement.rooms': 'Смарт',
    'placement.total_price': '87120.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця Замарстинівська',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WlaxI2B.jpg',
  },
  {
    id: 'fs_3hpxcbdysf9mqgrz_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '209',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '19.85',
    'placement.rooms': 'Смарт',
    'placement.total_price': '79400.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#b7bdc7',
    'placement_status.crosstable_color': '#b7bdc7',
    'placement.status': 'продано',
    'placement_status.module_name': 'продано',
    'placement_status.crosstable_name': 'продано',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця Замарстинівська',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_6s8y1hpap9mklpze_uid',
    main_filter_img: 'https://showfiles.net/2WHuQxhN.jpg',
  },
  {
    id: 'fs_a9et7ziiytat9a0u_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '210',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '55.34',
    'placement.rooms': '1',
    'placement.total_price': '221360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '3 TWIN',
    'placement.note': 'Вулиця Замарстинівська, вуличка перпендикулярна Замарстинівській',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row3': 'захід, північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '19',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WD6PjhJ.jpg',
  },
  {
    id: 'fs_yzxghhfy6j6jzlxf_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '211',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '22.88',
    'placement.rooms': 'Смарт',
    'placement.total_price': '91520.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вуличка перпендикулярна Замарстинівській',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '19',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHFSj24.jpg',
  },
  {
    id: 'fs_x172e9t3aag4ux68_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '212',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '22.34',
    'placement.rooms': 'Смарт',
    'placement.total_price': '89360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2 TWIN',
    'placement.note': 'Вуличка перпендикулярна Замарстинівській',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WD6FP2b.jpg',
  },
  {
    id: 'fs_kimipdtyyj0ngqzu_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '213',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '23.02',
    'placement.rooms': 'Смарт',
    'placement.total_price': '92080.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вуличка перпендикулярна Замарстинівській',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFPj2f.jpg',
  },
  {
    id: 'fs_euwv56y8j78p7q75_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '214',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '23.34',
    'placement.rooms': 'Смарт',
    'placement.total_price': '93360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2 TWIN',
    'placement.note': 'Вуличка перпендикулярна Замарстинівській',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHuPj2p.jpg',
  },
  {
    id: 'fs_vb5n3kwo4mk9hsoc_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '215',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '20.71',
    'placement.rooms': 'Смарт',
    'placement.total_price': '82840.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вуличка перпендикулярна Замарстинівській',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WD6Ag2z.jpg',
  },
  {
    id: 'fs_4r2xmpqods58s7iq_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '216',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.38',
    'placement.rooms': 'Смарт',
    'placement.total_price': '85520.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFwQ2U.jpg',
  },
  {
    id: 'fs_fyqmyscyl4y0lkrz_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '217',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.61',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86440.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFQx2X.jpg',
  },
  {
    id: 'fs_unimoid92cuu34ps_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '218',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.56',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86240.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WlaPj2t.jpg',
  },
  {
    id: 'fs_y4v4h6kd3qivkfyo_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_tkkh24gr7vx3fvwz_uid',
    ],
    'placement.numeration': '219',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '2',
    ],
    'placement.total_area': '21.72',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86880.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFAg22.jpg',
  },
  {
    id: 'fs_gqe9635r1hk5g6hf_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '301',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.70',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2W6wjc2h.jpg',
  },
  {
    id: 'fs_ai276wv533yzhnyd_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '302',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.16',
    'placement.rooms': 'Смарт',
    'placement.total_price': '84640.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFay2R.jpg',
  },
  {
    id: 'fs_qyammrbuhssuox2c_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '303',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '20.62',
    'placement.rooms': 'Смарт',
    'placement.total_price': '82480.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFjchG.jpg',
  },
  {
    id: 'fs_pt5ttw0nsoenhdys_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '304',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '24.45',
    'placement.rooms': 'Смарт',
    'placement.total_price': '97800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WlaAg2V.jpg',
  },
  {
    id: 'fs_mpcechzgwmav0ane_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '305',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '22.15',
    'placement.rooms': 'Смарт',
    'placement.total_price': '88600.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHuFP2Z.jpg',
  },
  {
    id: 'fs_koy72239oyo9fxe9_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '306',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.58',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86320.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHFQg28.jpg',
  },
  {
    id: 'fs_q2b8p1736dzg3jcr_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '307',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '22.07',
    'placement.rooms': 'Смарт',
    'placement.total_price': '88280.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#b7bdc7',
    'placement_status.crosstable_color': '#b7bdc7',
    'placement.status': 'продано',
    'placement_status.module_name': 'продано',
    'placement_status.crosstable_name': 'продано',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_6s8y1hpap9mklpze_uid',
    main_filter_img: 'https://showfiles.net/2WD6Ag21.jpg',
  },
  {
    id: 'fs_vc8hz6n1wm2i4m21_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '308',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.78',
    'placement.rooms': 'Смарт',
    'placement.total_price': '87120.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WlaxI2B.jpg',
  },
  {
    id: 'fs_nh4uf1apfp2pb0z2_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '309',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '19.85',
    'placement.rooms': 'Смарт',
    'placement.total_price': '79400.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHuQxhN.jpg',
  },
  {
    id: 'fs_z1zdj61775t8natq_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '310',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '55.34',
    'placement.rooms': '1',
    'placement.total_price': '221360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '3 TWIN',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row3': 'північ, захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '19',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WD6PjhJ.jpg',
  },
  {
    id: 'fs_j2zz0ubxp2jjhy68_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '311',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '22.88',
    'placement.rooms': 'Смарт',
    'placement.total_price': '91520.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '19',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WHFSj24.jpg',
  },
  {
    id: 'fs_vdke94aga5ohyl7f_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '312',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '22.34',
    'placement.rooms': 'Смарт',
    'placement.total_price': '89360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2 TWIN',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WD6FP2b.jpg',
  },
  {
    id: 'fs_2wdzofh0u5newtfl_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '313',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '23.02',
    'placement.rooms': 'Смарт',
    'placement.total_price': '92080.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFPj2f.jpg',
  },
  {
    id: 'fs_1cz0fc1c8nzcf49e_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '314',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '23.34',
    'placement.rooms': 'Смарт',
    'placement.total_price': '93360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2 TWIN',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WHuPj2p.jpg',
  },
  {
    id: 'fs_5xzgvcdze9zvugs2_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '315',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '20.71',
    'placement.rooms': 'Смарт',
    'placement.total_price': '82840.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WD6Ag2z.jpg',
  },
  {
    id: 'fs_9iwt2bwpx3w69iuq_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '316',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.38',
    'placement.rooms': 'Смарт',
    'placement.total_price': '85520.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFwQ2U.jpg',
  },
  {
    id: 'fs_0o3un2spey4447fz_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '317',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.61',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86440.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFQx2X.jpg',
  },
  {
    id: 'fs_qr5hqwwpwn0wzxl2_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '318',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.56',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86240.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WlaPj2t.jpg',
  },
  {
    id: 'fs_sj1ubree2i8i5ogy_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '319',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '21.72',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86880.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#8f9d6a',
    'placement_status.crosstable_color': '#8f9d6a',
    'placement.status': 'вільно',
    'placement_status.module_name': 'вільно',
    'placement_status.crosstable_name': 'вільно',
    'placement_status.show_in_module': 'show',
    'placement_status.amo_can_be_set_for_deal': '1',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_om6b4ba54pmcut0f_uid',
    main_filter_img: 'https://showfiles.net/2WMFAg22.jpg',
  },
  {
    id: 'fs_35z7n62oatyjbfzy_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_jis7cfohtyp7728a_uid',
    ],
    'placement.numeration': '320',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '3',
    ],
    'placement.total_area': '32.20',
    'placement.rooms': '1',
    'placement.total_price': '128800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '4 ІНКЛЮЗИВНЕ',
    'placement.note': 'Двір',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2Wlajc2L.jpg',
  },
  {
    id: 'fs_ftjpszworytjykat_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '401',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.70',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2W6wjc2h.jpg',
  },
  {
    id: 'fs_maedh2d617tnyr6v_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '402',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.16',
    'placement.rooms': 'Смарт',
    'placement.total_price': '84640.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFay2R.jpg',
  },
  {
    id: 'fs_hsjq9897lyqpguvi_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '403',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '20.62',
    'placement.rooms': 'Смарт',
    'placement.total_price': '82480.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFjchG.jpg',
  },
  {
    id: 'fs_blywfonxc9o5ykll_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '404',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '24.45',
    'placement.rooms': 'Смарт',
    'placement.total_price': '97800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WlaAg2V.jpg',
  },
  {
    id: 'fs_ex4bm1lo7427nrcr_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '405',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '22.15',
    'placement.rooms': 'Смарт',
    'placement.total_price': '88600.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WHuFP2Z.jpg',
  },
  {
    id: 'fs_8hw7wzcu2w4clweu_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '406',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.58',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86320.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WHFQg28.jpg',
  },
  {
    id: 'fs_ahnjaulojdoxxtt3_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '407',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '22.07',
    'placement.rooms': 'Смарт',
    'placement.total_price': '88280.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WD6Ag21.jpg',
  },
  {
    id: 'fs_nk42c5hphrorcbf8_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '408',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.78',
    'placement.rooms': 'Смарт',
    'placement.total_price': '87120.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WlaxI2B.jpg',
  },
  {
    id: 'fs_fb7z2t0xlyl6mq7q_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '409',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '19.85',
    'placement.rooms': 'Смарт',
    'placement.total_price': '79400.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '161',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WHuQxhN.jpg',
  },
  {
    id: 'fs_9jux61cxyeoap4f4_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '410',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '55.34',
    'placement.rooms': '1',
    'placement.total_price': '221360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '3',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row3': 'північ, захід',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '19',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WD6PjhJ.jpg',
  },
  {
    id: 'fs_5zndof9sc05yogkq_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '411',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '22.88',
    'placement.rooms': 'Смарт',
    'placement.total_price': '91520.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WHFSj24.jpg',
  },
  {
    id: 'fs_i40iy37dak8vr4xc_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '412',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '22.34',
    'placement.rooms': 'Смарт',
    'placement.total_price': '89360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WD6FP2b.jpg',
  },
  {
    id: 'fs_z7dp2p7cbw9pn7q9_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '413',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '23.02',
    'placement.rooms': 'Смарт',
    'placement.total_price': '92080.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFPj2f.jpg',
  },
  {
    id: 'fs_6mwcl08dvf5lgbhd_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '414',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '23.34',
    'placement.rooms': 'Смарт',
    'placement.total_price': '93360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WHuPj2p.jpg',
  },
  {
    id: 'fs_jtp15f69u31d5dz7_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '415',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '20.71',
    'placement.rooms': 'Смарт',
    'placement.total_price': '82840.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '40',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WD6Ag2z.jpg',
  },
  {
    id: 'fs_rmekgzbt7pbto1nc_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '416',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.38',
    'placement.rooms': 'Смарт',
    'placement.total_price': '85520.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFwQ2U.jpg',
  },
  {
    id: 'fs_5il1wxpna2bses3y_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '417',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.61',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86440.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFQx2X.jpg',
  },
  {
    id: 'fs_mmppp28gigkw5op1_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '418',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.56',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86240.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '2',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WlaPj2t.jpg',
  },
  {
    id: 'fs_4c91tmwyu94ddtxv_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '419',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '21.72',
    'placement.rooms': 'Смарт',
    'placement.total_price': '86880.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '1',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2WMFAg22.jpg',
  },
  {
    id: 'fs_825aqhx6be56s9yi_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_hd1p9tq4m5osfnrt_uid',
    ],
    'placement.numeration': '420',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '4',
    ],
    'placement.total_area': '32.20',
    'placement.rooms': '1',
    'placement.total_price': '128800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.tag': '4 ІНКЛЮЗИВНЕ',
    'placement.note': 'Двір',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.best_spinner_stops': [
      {
        stopNumber: '93',
        'entity-view-name': 'house',
        'entity-view-name-id': 'fs_no1p481x5bfwyqnx_uid',
      },
    ],
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
    main_filter_img: 'https://showfiles.net/2Wlajc2L.jpg',
  },
  {
    id: 'fs_goqqwdogkvol29hn_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '501',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '22.67',
    'placement.rooms': 'Смарт',
    'placement.total_price': '90680.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_pw2qslng0vz9hmxi_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '502',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '22.52',
    'placement.rooms': 'Смарт',
    'placement.total_price': '90080.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_0apbfrp9kaftw2ta_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '503',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '29.45',
    'placement.rooms': 'Смарт',
    'placement.total_price': '117800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'схід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_dtli2fbnq917akq1_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '504',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '37.06',
    'placement.rooms': '1',
    'placement.total_price': '148240.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_zcqyvbcq71rxrn3t_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '505',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '40.17',
    'placement.rooms': '1',
    'placement.total_price': '160680.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_8egxa1z1wxn70u3i_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '506',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '38.09',
    'placement.rooms': '1',
    'placement.total_price': '152360.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'захід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_eqzsdr4jf021u8rf_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '507',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '40.07',
    'placement.rooms': '1',
    'placement.total_price': '160280.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'північ, захід',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_4j1g5ek4uy5czhd3_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '508',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '32.99',
    'placement.rooms': '1',
    'placement.total_price': '131960.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_q2xb6bdfdyvydatk_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '509',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '21.06',
    'placement.rooms': 'Смарт',
    'placement.total_price': '84240.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_dg6jk8ci0vm3ejgb_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '510',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '20.89',
    'placement.rooms': 'Смарт',
    'placement.total_price': '83560.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_b6ta3m0qramdsi1t_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '511',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '23.11',
    'placement.rooms': 'Смарт',
    'placement.total_price': '92440.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Вулиця',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row0': 'тераса',
    'placement.row2': 'тераса',
    'placement.row3': 'північ',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_o6eenkxbi74f480k_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '512',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '23.36',
    'placement.rooms': 'Смарт',
    'placement.total_price': '93440.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_ce45z1rs5rk2c6iv_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '513',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '23.20',
    'placement.rooms': 'Смарт',
    'placement.total_price': '92800.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_kpcrfggmxm8qn4i4_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '514',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '23.33',
    'placement.rooms': 'Смарт',
    'placement.total_price': '93320.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_oe5mbi0uwgdiwb7n_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '515',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '22.79',
    'placement.rooms': 'Смарт',
    'placement.total_price': '91160.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': 'Смарт',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
  {
    id: 'fs_fcjekq6sn8m1gx4n_uid',
    'placement.type': 'міні-помешкання',
    house: 'fs_no1p481x5bfwyqnx_uid',
    section: 'fs_aoh1x347jlhdu38p_uid',
    floor_ids: [
      'fs_r2rjhoe6y4pz5eoa_uid',
    ],
    'placement.numeration': '516',
    'placement.house': '1',
    'placement.section': 'Фронтальна будівля',
    'placement.floor': [
      '5',
    ],
    'placement.total_area': '32.50',
    'placement.rooms': '1',
    'placement.total_price': '130000.00',
    'placement.price_per_sq_m': '4000.00',
    'placement_status.color': '#dacbb4',
    'placement_status.crosstable_color': '#dacbb4',
    'placement.status': 'бронь',
    'placement_status.module_name': 'бронь',
    'placement_status.crosstable_name': 'бронь',
    'placement_status.show_in_module': 'hide',
    'placement_status.amo_can_be_set_for_deal': '0',
    'placement_status.amo_only_one_deal_placement': '0',
    'placement.note': 'Двір',
    'placement.planning_type': '1 спальня',
    'placement.pdfs': [],
    'placement.row3': 'південь',
    'placement.row9': '1',
    'placement.gallery_images_transform': [],
    'placement_status.id': 'fs_tkymdd2jy7el0851_uid',
  },
];
export const mockVisibilityModel = {
  'placement.additional_advantage': false,
  'placement.additional_condition': false,
  'placement.balcony_area': false,
  'placement.bathrooms': false,
  'placement.bedrooms': false,
  'placement.house': false,
  'placement.living_area': false,
  'placement_status.module_name': false,
  'placement.status': false,
  'placement.type': false,
  'placement.price_per_sq_m_alternative': false,
  'placement.rooms': false,
  'placement.row0': false,
  'placement.row1': false,
  'placement.row2': false,
  'placement.row4': false,
  'placement.row5': false,
  'placement.row6': false,
  'placement.row7': false,
  'placement.row8': false,
  'placement.row9': false,
  'placement.section': false,
  'placement.tag': false,
  'placement.total_price_alternative': false,
};
